import { PromptTemplateType } from '@repo/shared/dtos/organization'
import { Location } from 'react-router-dom'

export enum RouteNames {
  Admin = 'admin',
  Beneficiaries = 'beneficiaries',
  BeneficiaryChat = 'chat',
  BeneficiaryTasks = 'tasks',
  Demo = 'demo',
  Login = 'login',
  Onboarding = 'onboarding',
  Organizations = 'org',
  ResetPassword = 'reset-password',
  Root = '/',
  SignUp = 'signup-202505',
  Sudo = 'super-admin',
}

export enum SearchParamsKeyNames {
  View = 'view',
}

export const SearchParamsViewNames = {
  ACCOUNT: 'account',
  BENEFICIARY_APP: 'beneficiaryApp',
  BENEFICIARY_LIST: 'beneficiaryList',
  BENEFICIARY_PROFILE_TEMPLATE: 'beneficiaryProfileTemplate',
  CATEGORIES: 'categories',
  CHAT_MESSAGE_SETTINGS: 'chatMessageSettings',
  DESCRIPTION: 'description',
  FEEDBACKS: 'feedbacks',
  REFRESH_BENEFICIARIES: 'refreshBeneficiaries',
  INSIGHTS_DASHBOARD: 'insightsDashboard',
  INSIGHTS_NEW: 'insightsNew',
  INSIGHTS_EDIT: 'insightsEdit',
  INSIGHTS_CHAT: 'insightsChat',
  INSIGHTS_LIST: 'insightsList',
  MEMBERS: 'members',
  METHODOLOGY: 'methodology',
  PROMPTS: 'prompts',
  SOURCES_COMMON: 'commonSources',
  SOURCES_PRIVATE: 'privateSources',
  SOURCES_PUBLIC: 'publicSources',
  STRUCTURED_DATA: 'structuredData',
  ...PromptTemplateType,
} as const

export const isRoute = (routeName: RouteNames, pathname: Location['pathname']): boolean => {
  switch (routeName) {
    case RouteNames.Beneficiaries:
    case RouteNames.Organizations:
      return pathname.includes(routeName) && new RegExp(`\\/${routeName}\\/[^/]+$`).test(pathname)

    case RouteNames.Root:
      return pathname === routeName.toString()

    default:
      return pathname.endsWith(RouteNames.Root + routeName)
  }
}

export const buildRoute = (routeName: RouteNames, params?: string | string[]): string => {
  if (params) return `/${routeName}/${typeof params === 'string' ? params : params.join('/')}`
  return `/${routeName}`
}

export const buildSearchParam = (
  searchParamsKey: string,
  keyName: typeof SearchParamsViewNames | string,
  otherParams?: Record<string, string>,
): string => {
  if (typeof keyName !== 'string' || !keyName.trim())
    throw new Error('keyName must be a non-empty string')
  let params = `?${searchParamsKey}=${keyName}`
  if (otherParams) {
    for (const [key, value] of Object.entries(otherParams)) {
      params += `&${key}=${value}`
    }
  }
  return params
}

export function getRouteNameFromPath(pathname: string): RouteNames {
  // Loop over all RouteNames to find a match
  for (const route of Object.values(RouteNames)) {
    if (isRoute(route, pathname)) return route
  }
  return RouteNames.Root
}
